import React from 'react';

const MetaPartnerSection = () => {
  const stats = [
    { label: "Active Instagram & Facebook Sellers", value: "35k+" },
    { label: "Total Reels & Posts Optimized", value: "1.2M+" },
    { label: "AI Automation Accuracy", value: "85%" },
    { label: "Average Setup Time", value: "15m" },
  ];

  return (
    <section className="py-20 lg:py-24 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="container mx-auto px-4">
        {/* Meta Partner Banner */}
        <div className="max-w-5xl mx-auto mb-24">
          <div className="bg-gray-50 dark:bg-gray-800/50 rounded-[3rem] p-10 lg:p-16 flex flex-col md:flex-row items-center justify-between gap-10 border border-gray-100 dark:border-gray-700 text-center md:text-left transition-all hover:border-purple-500/30">
            <div className="max-w-xl">
              <h2 className="text-3xl lg:text-4xl font-black text-gray-900 dark:text-white mb-4">Official Meta Business Partner</h2>
              <p className="text-xl text-gray-500 dark:text-gray-400 leading-relaxed font-medium italic">"ReelTale is built using Official Instagram & Facebook systems."</p>
            </div>
            <div className="flex-shrink-0 bg-white dark:bg-gray-900 p-6 rounded-3xl shadow-sm">
              <img src="/assets/revamp/social-icons/Meta Business Partne.png" alt="Meta Partner" className="h-12 lg:h-14 w-auto dark:brightness-0 dark:invert opacity-90" />
            </div>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 py-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="text-6xl lg:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-b from-gray-900 to-gray-600 dark:from-white dark:to-gray-400 mb-4 tracking-tighter transition-transform group-hover:scale-105 duration-500">
                {stat.value}
              </div>
              <div className="text-sm lg:text-base font-bold uppercase tracking-widest text-gray-400 dark:text-gray-500 max-w-[200px] mx-auto leading-tight">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetaPartnerSection;
